

















import {Component, Vue} from 'vue-property-decorator';
import TableRoute from '@c/tables/TableRoute.vue';
import {Can} from '@casl/vue';
import {BearingsTableHeader} from './interfaces';
import bearingsStoreModule from '@/store/modules/bearingsModule';

@Component({
  components: {
    TableRoute,
    Can,
  },
})
export default class BearingsView extends Vue {
  headers: BearingsTableHeader[] = [
    {
      text: 'Марка',
      value: 'name',
      sortable: true,
    },
    {
      text: 'Описание',
      value: 'description',
      sortable: false,
    },
  ];

  get apiStore() {
    return bearingsStoreModule;
  }
}
